import { Observable, of } from "rxjs";
import { catchError, delay, map } from "rxjs/operators";

export function mockGraphQl<T>(
  request: Observable<T>,
  data: any
): Observable<T> {
  return request.pipe(
    catchError(() => of(data).pipe(delay(Math.floor(Math.random() * 1000)))),
    delay(Math.floor(Math.random() * 1000)),
    map(() => data)
  );
}

export function mockClassFactory<T>(
  ctorImpls: new (...args: any[]) => T,
  ctorMock: new (...args: any[]) => T
) {
  return function (...args: any[]) {
    return mockClass(ctorImpls, ctorMock, args);
  };
}

export function mockClass<T>(
  ctorImpls: new (...args: any[]) => T,
  ctorMock: new (...args: any[]) => T,
  args: any[]
): T {
  return new ctorMock(...args);
}
